<!-- CTA -->
@if (!isLoading) {
  <div class="container content-space-2">
    <div class="w-lg-75 text-center mx-lg-auto">
      <!-- <figure class="mb-7">
      <img class="img-fluid" src="./../../../assets/img/backgrounds/undraw_handcrafts_exclamation_mark.svg" alt="Image Description" style="width: 7rem;">
    </figure> -->
    <h1 class="mb-7">You are not allowed to access the account on Web. Please contact your workspace superadmin.</h1>
    <a class="link link-pointer" routerLink='/sign-out' routerLinkActive="active">Sign Out</a>
    @if (availableMemberships.length > 0) {
      <div style="margin-bottom: 20px; margin-top : 30px;">
        <p>Switch To Other Available Workspaces</p>
        <mat-chip-listbox aria-label="available account" selectable="true">
          @for (membership of availableMemberships; track membership) {
            <mat-chip-option style="cursor: pointer; background-color: #3059C8; color: white;" #c
              [value]="membership" color="primary" (selectionChange)="toggleSelection($event)">
              {{membership.account.accountName | titlecase}}@if (membership.userAccountStatus && membership.userAccountStatus == 'APPROVED') {
              <span class="ml-1">- Your Have Been Invited</span>
              }
              @if (membership.userAccountStatus && membership.userAccountStatus == 'APPROVED') {
                <button class="btn-primary" (click)="acceptMembership($event, membership)">Accept</button>
                }&nbsp;&nbsp;
                @if (membership.userAccountStatus && membership.userAccountStatus == 'APPROVED') {
                  <button class="btn-danger" (click)="rejectMembership($event, membership)">Reject</button>
                }
              </mat-chip-option>
            }
          </mat-chip-listbox>
        </div>
      }
    </div>
  </div>
}
<!-- End CTA -->





